import { commonDefaultSettings } from '../commonDefaultSettings';

/**
  @deprecated константа заменена на хук. Например: choiceSettings => useChoiceSettings
*/

export const phoneSettings = {
  ...commonDefaultSettings,
  label: 'Phone',
  hint: '',
  fieldID: 'phone',
  showPlaceholder: true,
  defaultCountry: {
    mode: 'auto' as const,
    countryCode: undefined
  }
};
